import React from "react";

const DeleteAccountPage = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2>Delete Your Account</h2>

        <p>
          If you want to delete your PharmaHelp account, please follow the steps below:
        </p>

        <ul>
          <li>Send an email to <b>info@pharmahelp.co.in</b></li>
          <li>Mention your registered phone number</li>
          <li>Our team will verify and delete your account</li>
        </ul>

        <p><b>Note:</b> Your account and all associated data will be deleted within 24–48 hours.</p>

        <a href="mailto:info@pharmahelp.co.in">
          <button style={styles.button}>Send Email</button>
        </a>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "#f5f5f5",
  },
  card: {
    background: "#fff",
    padding: "30px",
    borderRadius: "10px",
    width: "350px",
    textAlign: "center",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
  },
  button: {
    marginTop: "20px",
    padding: "10px 20px",
    background: "#ff4d4f",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default DeleteAccountPage;